import { render, staticRenderFns } from "./BroadcastMessageForm.vue?vue&type=template&id=b8a1c684"
import script from "./BroadcastMessageForm.vue?vue&type=script&lang=js"
export * from "./BroadcastMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports